module.exports = __webpack_public_path__ + "img/fb-btn-grey.44fbed97.svg";